export enum ValidationSignUpErrorText {
    EMAIL_IS_EMPTY = 'Введите Email!',
    EMAIL_IS_INVALID = 'Проверьте ваш Email!',
    NAME_IS_EMPTY = 'Введите ник!',
    PASSWORD_IS_EMPTY = 'Введите пароль!',
    PASSWORD_IS_INVALID = 'Введите надежный пароль!',
    YEARS_AGREEMENT = 'Подтвердите свой возраст!',
    POLICY_AGREEMENT = 'Подтвердите согласие с условиями использования!',
}